import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Grid from '../components/Grid'
import styled from 'styled-components'
import request from "../utils/request";

const PlaylistLink = styled.a`
  display: flex;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  text-decoration: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`

@observer
export default class TrainerGuides extends Component {
  @observable miTrainer = null

  @action
  setMiTrainer = miTrainer => this.miTrainer = miTrainer

  getMiTrainer = async () => {
    const req = await request('/api/user/getFields')

    if (req.success) {
      this.setMiTrainer(req.data.fields.miTrainer)
    }
  }

  componentDidMount() {
    this.getMiTrainer()
  }
  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout
          title="Trainer's Guides"
          backHref="/resources"
          backText="Resources"
        >
          {this.miTrainer ?
              <Grid>
                <Grid.HalfCell>
                  <PlaylistLink color="blue" target="_blank"
                                href="https://drive.google.com/file/d/1MqIyPsXLW9LNEcvi3nc3Q4UhqEcYiphj/view">SEE
                    Counselor Training Guide</PlaylistLink>
                </Grid.HalfCell>
              </Grid> : false}
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/TrainerGuides.js